import axios from 'axios';
import { useToast } from 'vue-toastification';

const toast = useToast();

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
});

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('token_expires_at');
      localStorage.removeItem('roles');
      window.location.href = '/login';
    }

    if (error.response?.status === 403) {
      toast.error(error.response.data?.message || 'Доступ запрещён');
    }

    // Форматируем ошибку для удобного отображения
    if (error.response) {
      const data = error.response.data;
      let message = 'Ошибка сервера';

      if (typeof data === 'string') {
        message = data;
      } else if (data?.message) {
        message = data.message;
      } else if (data?.error) {
        message = data.error;
      }

      // Добавляем детали валидации если есть
      if (data?.errors && typeof data.errors === 'object') {
        const validationErrors = Object.values(data.errors).flat();
        if (validationErrors.length > 0) {
          message += '\n' + validationErrors.join('\n');
        }
      }

      error.userMessage = message;
    } else if (error.request) {
      error.userMessage = 'Нет ответа от сервера';
    } else {
      error.userMessage = error.message || 'Неизвестная ошибка';
    }

    return Promise.reject(error);
  }
);

export default instance;
